module.exports = __webpack_public_path__ + "prizes-button-draw.ee72a3fa.png";